"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cutLongString = exports.isActionToBeLogged = exports.getActionNotLogged = exports.MAX_STRING_SIZE = exports.logAction = exports.logInfo = exports.logWarning = exports.logError = exports.reportError = exports.logMemoryUsage = void 0;
const json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));
const types_1 = require("../../types");
const lodash_1 = __importDefault(require("lodash"));
const MAX_STRING_SIZE = 50000;
exports.MAX_STRING_SIZE = MAX_STRING_SIZE;
const genericLogging = (message, data) => {
    if (process.env.SHOULD_CONSOLE_LOG &&
        process.env.SHOULD_CONSOLE_LOG === "no") {
        // don't do anything if specified not to log console log.
        return;
    }
    // Trunk string if too long
    if (message.length > MAX_STRING_SIZE) {
        message = (0, exports.cutLongString)(data.message);
    }
    if ((data === null || data === void 0 ? void 0 : data.message) && data.message.length > MAX_STRING_SIZE) {
        data.message = (0, exports.cutLongString)(data.message);
    }
    const logObject = Object.assign(Object.assign({}, data), { message });
    let loggerFunction;
    switch (data.level) {
        case "error": {
            loggerFunction = console.error;
            break;
        }
        case "warning": {
            loggerFunction = console.warn;
            break;
        }
        default: {
            loggerFunction = console.info;
            break;
        }
    }
    if (process.env.NODE_ENV === "test" ||
        process.env.NODE_ENV === "local") {
        const keysToOmit = ["message", "level", "backend_version"];
        const simplifiedLogObject = (0, lodash_1.default)(logObject)
            .omit(keysToOmit)
            .omitBy(lodash_1.default.isNil)
            .value();
        const details = lodash_1.default.isEmpty(simplifiedLogObject) ? "" : simplifiedLogObject;
        loggerFunction(`\n${message}`);
        details && loggerFunction(details);
    }
    else {
        loggerFunction((0, json_stringify_safe_1.default)(logObject));
    }
};
const logError = (errorMessage, data = { message: errorMessage }) => {
    genericLogging(errorMessage, Object.assign(Object.assign({}, data), { level: "error" }));
};
exports.logError = logError;
const logWarning = (infoMessage, data = { message: infoMessage }) => {
    genericLogging(infoMessage, Object.assign(Object.assign({}, data), { level: "warning" }));
};
exports.logWarning = logWarning;
const logInfo = (infoMessage, data = { message: infoMessage }) => {
    genericLogging(infoMessage, Object.assign(Object.assign({}, data), { level: "info" }));
};
exports.logInfo = logInfo;
const logAction = (logAction) => {
    // Trunk string if too long
    if (!logAction.data)
        logAction.data = "";
    let { user_id, action_code, data, status, second_status } = logAction;
    if (data.length >= MAX_STRING_SIZE) {
        data = data.substring(0, MAX_STRING_SIZE);
    }
    let logTitle = `USER: ${user_id} ACTION: ${action_code}`;
    let logData = { message: logTitle };
    if (status === 200) {
        // request successful. Try to see if there is a business error in it
        if (second_status !== "SUCC") {
            // business error. Log the error correctly
            logTitle = `Business Error for action ${action_code}`;
            logData = Object.assign(Object.assign({}, logAction), { message: logTitle, data, level: "warning", type: "action" });
            logWarning(logTitle, logData);
        }
        else {
            // real success
            logTitle = `Action ${action_code} executed correctly`;
            logData = Object.assign(Object.assign({}, logAction), { message: logTitle, data, level: "info", type: "action" });
            logInfo(logTitle, logData);
        }
    }
    else {
        // application error. Log the error correctly
        logTitle = `Application Error for action ${action_code}`;
        logData = Object.assign(Object.assign({}, logAction), { message: logTitle, data, level: "error", type: "action" });
        logError(logTitle, logData);
    }
};
exports.logAction = logAction;
const reportError = (error) => {
    var _a;
    error.message = (_a = error.message) === null || _a === void 0 ? void 0 : _a.substring(0, MAX_STRING_SIZE);
    logError(error.message);
};
exports.reportError = reportError;
const logMemoryUsage = (msg) => {
    const used = process.memoryUsage();
    let l = "";
    for (let key in used) {
        l += `${key} ${Math.round((used[key] / 1024 / 1024) * 100) / 100} MB, `;
    }
    logInfo(`MEMORY_USAGE ${msg} : ${l}`);
};
exports.logMemoryUsage = logMemoryUsage;
const getActionNotLogged = () => {
    const result = [];
    result.push(types_1.DETAILED_ACTION_CODE.RecordUserLocations);
    return result;
};
exports.getActionNotLogged = getActionNotLogged;
const isActionToBeLogged = (actionCode // this action is either ENDPOINT_UNIQUE_ACCESS_CODE for web, or DETAILED_ACTION_CODE for mobile.
// both are set on the backend, so they are supposed to be "safe"
) => {
    // Exception to the "FETCH_" actionCodes not being logged
    const actionNotLogged = (0, exports.getActionNotLogged)();
    if (actionNotLogged.includes(actionCode) ||
        actionCode.startsWith(types_1.ACTION_TYPE.FETCH))
        return false;
    return true;
};
exports.isActionToBeLogged = isActionToBeLogged;
const cutLongString = (message, maxStringSize = MAX_STRING_SIZE) => {
    return `${message.substring(0, maxStringSize / 2)}...${message.substring(message.length - maxStringSize)}`;
};
exports.cutLongString = cutLongString;
